import { Observable } from './observable';
import { ModalType } from './types';

// Multi modal can showing
export const modalObservable = new Observable<ModalType[]>([]);
